import{isNil as o}from"../isNil/isNil.js";import{stringToPath as t}from"../../../node_modules/remeda/dist/es/stringToPath.js";const r=r=>e=>function(t,r){let e=r,i=0;for(;!o(e)&&i<t.length;)e=e[t[i]],i+=1;return e}(t(r),e);export{r as getProperty};
//# sourceMappingURL=getProperty.js.map
